import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslator } from 'tradera-lang/translate';
import PropTypes from 'prop-types';
import Tags from '../tags/tags';
import { fetchTrendingSearchesIfNeeded } from 'tradera-state/views/start-page/actions';
import HotIcon from '@tradera/blueprint/theme/icons2/hot.svg?jsx';
import './trending-searches-tags.scss';

const TrendingSearchesTags = ({ className, inHeader }) => {
    const { t } = useTranslator();
    const dispatch = useDispatch();

    const tags = useSelector(
        state => state.views.startPage.trendingSearches.items
    );

    useEffect(() => {
        dispatch(fetchTrendingSearchesIfNeeded());
    }, [dispatch]);

    if (!tags || tags.length === 0) {
        return null;
    }

    const textOrIcon = inHeader ? (
        <span className="ml-1 mr-1 mr-md-0 text-styled text-light align-text-bottom text-shadow">
            {t('trendingTags_searches')}:
        </span>
    ) : (
        <HotIcon className="icon" alt={t('trendingTags_searches')} />
    );

    return (
        <div
            className={`trending-searches-tags ${
                inHeader ? 'in-header' : ''
            } ${className}`}>
            {textOrIcon}
            <Tags
                gaCategory="Trending Searches"
                gaAction="Navigation"
                tags={tags}
                titleOnSameLine
                scroll={!inHeader}
            />
        </div>
    );
};

TrendingSearchesTags.defaultProps = {
    className: ''
};

TrendingSearchesTags.propTypes = {
    className: PropTypes.string,
    inHeader: PropTypes.bool.isRequired
};

export default TrendingSearchesTags;
